import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers, MOCKUP_URL } from "../data/landing";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const cycle = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), 5000);
    };
    const first = window.setTimeout(cycle, 6000);
    const interval = window.setInterval(cycle, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:right-auto sm:w-[340px]" aria-live="polite" data-id="element-43" data-mp="164o984x5s1tn">
      <AnimatePresence data-id="element-44" data-mp="114tlga8ojsct">
        {show && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-2xl" data-id="element-45" data-mp="1fur307c3tjt1">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-46" data-mp="x2ybkhcoo6nf" />
            <div className="min-w-0" data-id="element-47" data-mp="28kg6qsg77xyc">
              <p className="text-[14px] leading-snug text-ink" data-id="element-48" data-mp="28jeoo40rmb74">
                <strong data-id="element-49" data-mp="23lmzhhri936m">{buyer.name}</strong> from <strong data-id="element-50" data-mp="23kld4h51gu9l">{buyer.country}</strong> just purchased the Clinical Pathway™
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-medium text-cta" data-id="element-51" data-mp="2anrur3odj6gw">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-52" data-mp="2fmmp92vpejgu" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-inkSoft transition-colors duration-150 ease-out hover:bg-sand hover:text-ink" aria-label="Dismiss notification" data-id="element-53" data-mp="2plkanwxu1wvm">
              <XIcon className="h-4 w-4" data-id="element-54" data-mp="21vpylhlc8ccf" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}